"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokTestimonialsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* Section Header */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Header</h4>
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Testimonials"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Client Acknowledgement Reviews"
            />
            <TextEditor
              label="Description"
              value={content.description}
              onChange={(v) => handleChange({ ...content, description: v })}
              placeholder="Join us for an exhilarating live auction..."
              multiline
            />
          </div>

          {/* Testimonials */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Testimonials</h4>
            <ListItemEditor
              label="Reviews"
              items={content.testimonials || [
                { title: "Unique discoveries", text: "I ordered a handcrafted chair and it exceeded my expectations! The craftsmanship is top-notch and it looks stunning in my living room. Definitely a place to shop for quality pieces.", name: "Emily Johnson", handle: "@emily", date: "22 March, 2026", rating: 5, avatar: "/assets/img/testimonial/testi_1_1.png" },
                { title: "Wonderful Bidding Items", text: "I ordered a handcrafted chair and it exceeded my expectations! The craftsmanship is top-notch and it looks stunning in my living room. Definitely a place to shop for quality pieces.", name: "John Doe", handle: "@john", date: "25 March, 2026", rating: 5, avatar: "/assets/img/testimonial/testi_1_2.png" },
                { title: "Wonderful Bidding Items", text: "I ordered a handcrafted chair and it exceeded my expectations! The craftsmanship is top-notch and it looks stunning in my living room. Definitely a place to shop for quality pieces.", name: "John Doe", handle: "@john", date: "25 March, 2026", rating: 5, avatar: "/assets/img/testimonial/testi_1_3.png" },
                { title: "Exceptional Theme Finds", text: "I ordered a handcrafted chair and it exceeded my expectations! The craftsmanship is top-notch and it looks stunning in my living room. Definitely a place to shop for quality pieces.", name: "Jarin Smith", handle: "@Jarin", date: "19 March, 2026", rating: 5, avatar: "/assets/img/testimonial/testi_1_4.png" },
                { title: "Loved the Experience", text: "The learning experience on Instacks is phenomenal. The platform is intuitive, courses are well-structured, and the community support is incredible. Worth every penny.", name: "Emily Johnson", handle: "@emily", date: "22 March, 2026", rating: 5, avatar: "/assets/img/testimonial/testi_1_1.png" },
              ]}
              itemSchema={[
                { key: "title", label: "Title", type: "text" },
                { key: "text", label: "Review Text", type: "textarea" },
                { key: "name", label: "Name", type: "text" },
                { key: "handle", label: "Handle", type: "text" },
                { key: "date", label: "Date", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, testimonials: items })}
              addItemText="Add Testimonial"
            />
          </div>
        </>
      }
    />
  );
}
